import React, {useEffect, useRef, useState} from "react";
import CategoryFilter from "./CategoryFilter";
import PriceRangeFilter from "./PriceRangeFilter";
import AgeRangeFilter from "./AgeRangeFilter";
import GradeRangeFilter from "./GradeRangeFilter";
import AvailabilityFilter from "./AvailabilityFilter";
import SortByFilter from "./SortByFilter";
import BrandFilter from "./BrandFilter";

export default function ProductFilter(){
    const [isFilterVisible, setIsFilterVisible] = useState(false); // Filter visibility state

    // Reference to detect clicks outside the filter
    const filterRef = useRef();

    // Close filter when clicking outside
    const handleOutsideClick = (e) => {
        if (filterRef.current && !filterRef.current.contains(e.target)) {
            setIsFilterVisible(false);
        }
    };

    // Listen for clicks outside the filter when it is open
    useEffect(() => {
        if (isFilterVisible) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isFilterVisible]);

    // Toggle filter visibility
    const toggleFilterVisibility = () => {
        setIsFilterVisible(!isFilterVisible);
    };

    // Close the filter
    const closeFilter = () => {
        setIsFilterVisible(false);
    };
    return(
        <>
            <div className="filter-button-container">
                <button className="filter-button" onClick={toggleFilterVisibility}>Filter</button>
            </div>
            {isFilterVisible && <div className="overlay" onClick={closeFilter}></div>}
            <div className={`product-filter ${isFilterVisible ? 'visible' : ''}`} ref={filterRef}>
                <button className="close-button" onClick={closeFilter}>X</button>
                <div className="category-card">
                    <SortByFilter />
                    <CategoryFilter />
                    <GradeRangeFilter />
                    <BrandFilter />
                    <AgeRangeFilter />
                    <br/>
                    <AvailabilityFilter />
                    <br/>
                    <PriceRangeFilter />
                </div>
            </div>
    </>
    )
}
